
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 17 17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#192638","cx":"8.5","cy":"8.5","r":"8.5"}}),_c('path',{attrs:{"d":"M8.375 5.386c.25 0 .445-.062.588-.187a.637.637 0 00.215-.506.637.637 0 00-.215-.506C8.82 4.062 8.624 4 8.376 4a.874.874 0 00-.577.187.623.623 0 00-.226.506c0 .213.075.381.226.506a.87.87 0 00.577.187zm1.408 6.864v-.55h-.814V6.475H7v.55h.814V11.7H7v.55h2.783z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    